import React, { useState, useEffect, useRef } from "react";

//mui imports
import { Box, Grid, Typography } from "@mui/material";
import Specialization from "./specialization";
import SubSpecialization from "./subspecialization";

//icons

//project imports

//third party libraries

//temp data

const CandidateSpecialization = () => {
  //const

  //services

  //states
  const [selectedSpecializationId, setSelectedSpecializationId] =
    useState(null);
  const [isTypeChange, setIsTypeChange] = useState(false);

  //methods
  //TODO :For Sunil : Change API calls and design
  //useEffects
  useEffect(() => {
    setIsTypeChange(true);
  }, [selectedSpecializationId]);

  return (
    <>
      <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 4 }}>
        <Grid
          sx={{
            background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
            paddingX: 2,
            paddingY: 1,
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" color="white.main">
              Candidate Specializations
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <Specialization
                onSelectSpecialization={setSelectedSpecializationId}
                selectedSpecializationId={selectedSpecializationId}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <SubSpecialization
                selectedSpecializationId={selectedSpecializationId}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </>
  );
};

export default CandidateSpecialization;
//
